import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const UPDATE_VENUE_SUCCESS = "UPDATE_VENUE_SUCCESS";

export interface UpdateVenueSuccessAction extends Action {
  type: typeof UPDATE_VENUE_SUCCESS;
  organization: OrganizationKeyName;
}

export const updateVenueSuccessAction = (
  organization: OrganizationKeyName
): UpdateVenueSuccessAction => ({
  type: UPDATE_VENUE_SUCCESS,
  organization,
});
